import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, notification, Select} from 'antd';

import {addPurchaseOrder} from './actions';
import {getSuppliers} from "../Supplier/actions";
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddPurchaseOrderForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dispensaryId !== this.props.dispensaryId) {
      this._load();
    }
  }

  _load = () => {
    const {dispensaryId} = this.props;
    if (dispensaryId) {
      this.props.getSuppliers({dispensaryId});
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {addPurchaseOrder, dispensaryId, form} = this.props;
    e.preventDefault();
    form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await addPurchaseOrder({...values, dispensaryId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err),
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, suppliers} = this.props;
    return (
      <Card title="Add Purchase Order">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Supplier"
          >
            {getFieldDecorator('supplierId', {
              rules: [
                {required: true, message: 'Please select a supplier'},
              ]
            })(
              <Select>
                {suppliers.map(({supplierId, name}) =>
                  <Option key={supplierId} value={supplierId}>{name}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Purchase Order
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddPurchaseOrderForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  addPurchaseOrder: PropTypes.func.isRequired,
  getSuppliers: PropTypes.func.isRequired,
  suppliers: PropTypes.array.isRequired,
};

const AddPurchaseOrderPage = Form.create()(AddPurchaseOrderForm);

const mapStateToProps = state => ({
  loading: state.supplier.gettingSuppliers || state.purchaseOrder.addPurchaseOrderLoading,
  dispensaryId: state.dispensary.selectedDispensaryId,
  suppliers: state.supplier.suppliers,
});

const mapDispatchToProps = dispatch => ({
  addPurchaseOrder: payload => (dispatch(addPurchaseOrder(payload))),
  getSuppliers: payload => (dispatch(getSuppliers(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPurchaseOrderPage);


// WEBPACK FOOTER //
// ./src/PurchaseOrder/AddPurchaseOrderPage.js